var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-work-executives-list"},_vm._l((_vm.executives),function(executive,i){return _c('CustomWorkExecutiveListItem',{key:i,attrs:{"editable":_vm.editable,"executive":executive},on:{"remove":_vm.remove}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }